import { h, Component } from 'preact';
import { Text } from 'preact-i18n';

/**
 * The "Ammo" tab tile on the profile page. Lives in the product registry
 * (components-other) so the Dyrejournal build, where the ammo module is
 * stripped, never carries the tile. profile.js renders it only when the
 * getter exists and the tenant has menuItems.ammoSales.
 */
class AmmoProfileTile extends Component {
    render() {
        const { view, darkmode, onToggle } = this.props;
        const active = view === 'ammo';
        const tone = darkmode ? 'bg-darkmode' : 'bg-lightmode';
        return (
            <div
                class={`d-flex flex-column align-items-center px-1 py-3 box-container ${active ? 'border border-primary bg-primary text-white' : tone}`}
                style='flex: 1 1 calc(25% - 0.5rem); min-width: 70px;'
                onClick={onToggle}
                data-view='ammo'
            >
                <span style='font-size: 1.5rem;'>
                    <i class='fa-solid fa-box-open' />
                </span>
                <small class='text-center font-style-narrow'><Text id='user.ammo'>Ammo</Text></small>
            </div>
        );
    }
}

export default AmmoProfileTile;
